module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Headphones-4eadc006e63bc179459900571974e2c5.svg";